import MPAEditSuperAdminUser from './MPAEditSuperAdminUser';

export default MPAEditSuperAdminUser;
